import { QueryKey, useMutation, useQueryClient } from 'react-query';
import { useHistory } from 'react-router-dom';
import { ROUTES } from 'routing';
import { MUTATION_KEYS, QUERY_KEYS } from 'shared/constants';
import { useService } from 'shared/providers';
import { PatchProductProps } from 'shared/service';
import { CommoditySqlView } from 'shared/types';

export function useUpdateProduct() {
  const { productService } = useService();
  const history = useHistory();
  const queryClient = useQueryClient();

  return useMutation<CommoditySqlView, Error, PatchProductProps, { previousData: [QueryKey, CommoditySqlView[]][] }>(
    request => productService.patchProduct(request),
    {
      mutationKey: MUTATION_KEYS.updateProduct,
      onSuccess: () => {
        history.push(ROUTES.products);
      },
      onSettled: (_, __, { newRow }) => {
        queryClient.invalidateQueries([QUERY_KEYS.commodities]);
        queryClient.invalidateQueries([QUERY_KEYS.customerPrices, newRow.productNumber]);
      },
    }
  );
}
